module.exports = __webpack_public_path__ + "img/House.61f48148.svg";